export default [{
    'navLabel': '首页',
    'linkUrl': 'home',
    'linkType': 1,
    // 'navSubList': [{
    //     'navLabel': '首页',
    //     'linkUrl': 'home',
    //     'linkType': 1
    //   },
    //   {
    //     'navLabel': '前沿资讯',
    //     'linkUrl': 'news',
    //     'linkType': 2
    //   },
    //   {
    //     'navLabel': '齿科学院',
    //     'linkUrl': 'school',
    //     'linkType': 2
    //   },
    //   {
    //     'navLabel': '在线商城',
    //     'linkUrl': 'mall',
    //     'linkType': 2
    //   },
    // ]
  },
  {
   'navLabel': 'Online设计平台',
   'linkUrl': 'order/mall',
   'linkType': 1,
   'navSubList': [{
       'navLabel': '服务单大厅',
       'linkUrl': 'order/mall',
       'linkType': 1
     },
     {
       'navLabel': '我的设计单',
       'linkUrl': 'order/des',
       'linkType': 1
     }
   ]
  },
  {
    'navLabel': 'AI视觉',
    'navIcon': '',
    'linkUrl': 'ai',
    'linkType': 1,
    // 'navSubList': [{
    //     'navLabel': '全部',
    //     'linkUrl': 'news',
    //     'linkType': 1
    //   }, {
    //     'navLabel': '新闻资讯',
    //     'linkUrl': 'news',
    //     'query': {
    //       'cataType': '1'
    //     },
    //     'linkType': 9
    //   },
    //   {
    //     'navLabel': '行业动态',
    //     'linkUrl': 'news',
    //     'query': {
    //       'cataType': '2'
    //     },
    //     'linkType': 9
    //   }
    // ]
  },
  {
    'navLabel': '医小智商城',
    'linkUrl': 'mall',
    'linkType': 1,
    // 'navSubList': [{
    // 		'navLabel': '全部',
    // 		'linkUrl': 'mall',
    // 		'linkType': 1
    // 	},
    // 	{
    // 		'navLabel': '口扫设备',
    // 		'linkUrl': 'mall',
    // 		'query': {
    // 		  'cataType': '1'
    // 		},
    // 		'linkType': 9
    // 	},
    // 	{
    // 		'navLabel': '工具配件',
    // 		'linkUrl': 'mall',
    // 		'query': {
    // 		  'cataType': '2'
    // 		},
    // 		'linkType': 9
    // 	},
    //   {
    //   	'navLabel': '其他',
    //   	'linkUrl': 'mall',
    //   	'query': {
    //   	  'cataType': '9'
    //   	},
    //   	'linkType': 9
    //   }
    // ]
  },
  {
    'navLabel': '软件中心',
    'linkUrl': 'agreement',
    'linkType': 1,
    'navSubList': [{
      'navLabel': '在线软件',
      'linkUrl': 'agreement',
      'query': {
        'agreeId': '23'
      },
      'linkType': 9
    },
      {
        'navLabel': '软件下载',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '24'
        },
        'linkType': 9
      },
      {
        'navLabel': '合作介绍',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '21'
        },
        'linkType': 9
      },
      {
        'navLabel': '医患沟通应用介绍',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '25'
        },
        'linkType': 9
      },
    ]
  },
  {
    'navLabel': '产品中心',
    'linkUrl': 'agreement',
    'linkType': 1,
    'navSubList': [
      {
        'navLabel': '设计说明',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '12'
        },
        'linkType': 9
      },
      {
        'navLabel': '售后服务',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '13'
        },
        'linkType': 9
      },
      {
        'navLabel': '下单操作流程',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '15'
        },
        'linkType': 9
      },
      {
        'navLabel': '接单操作流程',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '16'
        },
        'linkType': 9
      },
      {
        'navLabel': '种植模块说明',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '17'
        },
        'linkType': 9
      },
      {
        'navLabel': '固定模块说明',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '18'
        },
        'linkType': 9
      }
    ]
  },
  {
    'navLabel': '齿科学院',
    'linkUrl': 'agreement',
    'linkType': 1,
    'navSubList': [
      {
        'navLabel': '企业招聘',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '1'
        },
        'linkType': 9
      },
      {
        'navLabel': '荣誉奖项',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '2'
        },
        'linkType': 9
      },
      {
        'navLabel': '线上培训',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '3'
        },
        'linkType': 9
      },
      {
        'navLabel': '线下培训',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '4'
        },
        'linkType': 9
      }
    ]
  },
  {
    'navLabel': '行业新闻',
    'linkUrl': 'news',
    'linkType': 1,
    // 'navSubList': [{
    //     'navLabel': '全部',
    //     'navIcon': '',
    //     'linkUrl': 'school',
    //     'linkType': 1
    //   },
    //   {
    //     'navLabel': '知识中心',
    //     'linkUrl': 'school',
    //     'query': {
    //       'cataType': '1'
    //     },
    //     'linkType': 9
    //   },
    //   {
    //     'navLabel': '解决方案',
    //     'linkUrl': 'school',
    //     'query': {
    //       'cataType': '2'
    //     },
    //     'linkType': 9
    //   },
    //   {
    //     'navLabel': '相关案例',
    //     'linkUrl': 'school',
    //     'query': {
    //       'cataType': '3'
    //     },
    //     'linkType': 9
    //   },
    //   {
    //     'navLabel': '产品手册',
    //     'linkUrl': 'school',
    //     'query': {
    //       'cataType': '4'
    //     },
    //     'linkType': 9
    //   }
    // ]
  },
  {
    'navLabel': '联系我们',
    'linkUrl': 'agreement',
    'linkType': 1,
    'navSubList': [
      {
        'navLabel': '联系我们',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '31'
        },
        'linkType': 9
      },
      {
        'navLabel': '关于医小智',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '41'
        },
        'linkType': 9
      },
      {
        'navLabel': '售后服务',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '13'
        },
        'linkType': 9
      },
      {
        'navLabel': '在线客服',
        'linkUrl': 'agreement',
        'query': {
          'agreeId': '44'
        },
        'linkType': 9
      },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/assets/config/navDesList.js